import React, { useState } from 'react';
import { authAPI } from '../services/api';
import { toast } from 'react-toastify';
import { Link, useParams, useNavigate } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import PasswordInput from '../components/PasswordInput';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [passwords, setPasswords] = useState({ password: '', confirm_password: '' });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (passwords.password !== passwords.confirm_password) {
      toast.error('Passwords do not match.');
      return;
    }
    setLoading(true);
    setMessage('');
    try {
      await authAPI.resetPassword({ token, password: passwords.password });
      setMessage('Your password has been reset successfully. You can now log in.');
      toast.success('Password reset successfully.');
      setTimeout(() => navigate('/login'), 3000);
    } catch (error) {
      setMessage(error.response?.data?.message || 'Failed to reset password.');
      toast.error('Failed to reset password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <h2>Reset Password</h2>
      <p className="text-center text-muted mb-3">Enter your new password.</p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <PasswordInput
            placeholder="New Password"
            value={passwords.password}
            onChange={(e) => setPasswords({...passwords, password: e.target.value})}
            autoComplete="new-password"
            required
          />
        </div>
        <div className="form-group">
          <PasswordInput
            placeholder="Confirm New Password"
            value={passwords.confirm_password}
            onChange={(e) => setPasswords({...passwords, confirm_password: e.target.value})}
            autoComplete="new-password"
            required
          />
        </div>
        <button type="submit" className="btn btn-primary w-full mt-2" disabled={loading}>
          {loading ? 'Resetting...' : 'Reset Password'}
        </button>
      </form>
      {message && <p className="text-center mt-3">{message}</p>}
      <p className="text-center mt-3">
        <Link to="/login">Back to Login</Link>
      </p>
    </AuthLayout>
  );
};

export default ResetPassword;
